













































































import { Component, Prop, Vue } from "vue-property-decorator";
import { RequestStatus } from "../utils/constans";
import { formatBackTime } from "../utils/common";
import { iPersonInfo, iNew, iAward } from "../typings/personinfo";
import $api from "../api";
import mock from "../mock/home";

@Component
export default class BasicInfo extends Vue {
  private requestStatus: number = 0;
  private personInfo: String = "";
  private enPersonInfo: String = "";
  private newsList: iNew[] = [];
  private enNewsList: iNew[] = [];
  private awardList: iAward[] = [];
  private enAwardList: iAward[] = [];
  private dialogVisible: boolean = false;
  private dialogContent: string = '加载中';
  @Prop() private msg!: string;

  mounted() {
    // this.getPersonInfo();
    this.getBasicInfo();
    this.getRecentNews();
    // this.getAwardList();
  }

  getBasicInfo(){
    if (this.$store.state.offModel) {
      this.personInfo = mock.ch;
      this.enPersonInfo = mock.en;
    } else {
    $api.module.findContentByName('home_basic')
      .then((res) => {
          this.personInfo = (res as any).content;
      })

    $api.module.findContentByName('en_home_basic')
      .then((res) => {
          this.enPersonInfo = (res as any).content;
      })}
  }
  getPersonInfo() {
    $api.personInfo.findAllPersonalResumeClient().then(res => {
      this.requestStatus += 1;
      (res as any).map((record: iPersonInfo) => {
        if (record.language === "英语") {
          this.enPersonInfo = record.individual_resume;
        } else {
          this.personInfo = record.individual_resume;
        }
      });
    });
  }

  getRecentNews() {
    this.newsList = mock.News;
    this.enNewsList = mock.enNews;
    // $api.personInfo.findAllNewsClient().then(res => {
    //   this.requestStatus += 1;
    //   let list = [];
    //   list = (res as any)
    //   list.sort(this.sortNews)
    //   list.reverse();
    //   list.map((record: iNew) => {
    //     if ((record.language === "英语" && this.enNewsList.length < 5) || record.id == 1) {
    //       if(record.id == 1){
    //         this.enNewsList.unshift(record);
    //       }else{
    //        this.enNewsList.push(record);
    //       }
    //     }
    //     if ((record.language === "汉语" && this.newsList.length < 6) || record.id == 149 || record.id == 150) {
    //       if(record.id == 150 || record.id == 149){
    //         this.newsList.unshift(record);
    //       }else{
    //        this.newsList.push(record);
    //       }
    //     }
    //   });
    // });
  }

  sortNews(a: iNew, b: iNew){
    let temp = a.time.split("-")
    let aTime = Number(temp[2]) + Number(temp[1]) * 100 + Number(temp[0]) * 10000
    temp = b.time.split("-")
    let bTime = Number(temp[2]) + Number(temp[1]) * 100 + Number(temp[0]) * 10000
    return aTime - bTime
  }

  getAwardList() {
    $api.personInfo.findAllAwardHonorsClient().then(res => {
      this.requestStatus += 1;
      (res as any).map((record: iAward) => {
        if (record.language === "英语" && this.enAwardList.length < 5) {
          this.enAwardList.push(record);
        } else if (this.awardList.length < 5) {
          this.awardList.push(record);
        }
      });
    });
  }

  handleNewDetail(item: any){
    localStorage.setItem("new-datail-cache", JSON.stringify(item));
    this.$router.push({
      name: "NewDetail",
      params: {
        item
      }
    })
  }
}
